export default {
    mobileConversionConfig: {
        hideByDefault: true
    }
}
